@let dataPage = dataInstance | async;
@if (!(dataPage | isNil)) {
  <ng-container *transloco="let t; prefix: i18nScope">
    <div class="overflow-auto">
      <table
        mat-table
        matSort
        [actualSort]="dataPage.sort"
        [dataSource]="dataPage.data"
        [szgCoreTableSort]="columnsConfig()"
        [tableId]="id()"
      >
        @for (column of displayedColumns(); track column.id) {
          <ng-container [matColumnDef]="column.id">
            <th
              *matHeaderCellDef
              class="order-1"
              mat-header-cell
              mat-sort-header
              [attr.data-cy]="`${id()}_header_${$index}`"
              [disabled]="!column.sortable"
            >
              @if (column.headerIcon) {
                <mat-icon class="mr-1" [customMatSvgIcon]="column.headerIcon" />
              }
              {{ column.label | resolveTranslateAbleText }}
            </th>
            <td *matCellDef="let element" class="order-1" mat-cell>
              @if (column.cellContent | isConstructor) {
                <ng-container
                  *ngComponentOutlet="
                    column.cellContent;
                    inputs: element | resolveCellContentInputs: column
                  "
                />
              } @else if (column.cellContent | isStringResolver) {
                {{ column.cellContent | resolveString: element }}
              } @else {
                {{ element[column.field] }}
              }
            </td>
          </ng-container>
        }

        @let tableSettingsValue = tableSettings();
        @if (!(tableSettingsValue | isNil)) {
          <ng-container matColumnDef="settings">
            <th
              *matHeaderCellDef
              class="order-0 md:order-last !max-w-[6rem]"
              mat-header-cell
              [attr.data-cy]="`${id()}_header_settings`"
            >
              <!--              @let tableSettingsConfig = tableSettings();-->
              <!-- TODO @mate show/hide option -->
              <!--              @if (!(tableSettingsConfig | isNil)) {-->
              <!--                <pct-feature-table-material-settings-button-->
              <!--                  [columns]="columnsConfig()"-->
              <!--                  [config]="tableSettingsConfig"-->
              <!--                  [displayedColumns]="displayedColumnIds()"-->
              <!--                  [tableId]="id()"-->
              <!--                />-->
              <!--              }-->
            </th>
            <td
              *matCellDef="let element; let i = index"
              class="order-0 md:order-last !max-w-[6rem]"
              mat-cell
            >
              @let settingsColumnValue = rowActionsConfig();
              @let shouldShow = settingsColumnValue?.shouldShow;
              @let needSettingsCell = (shouldShow | isNil) ? true : (shouldShow | call: element);

              @if (!(settingsColumnValue | isNil) && !(needSettingsCell | isNil)) {
                @let isDisabled = settingsColumnValue?.isDisabled;
                @let settingsCellDisabled =
                  (isDisabled | isNil) ? false : (isDisabled | call: element);
                <pct-feature-table-material-settings-cell
                  [config]="settingsColumnValue.options"
                  [disabled]="settingsCellDisabled"
                  [index]="i"
                  [rowItem]="element"
                  [tableId]="id()"
                />
              }
            </td>
          </ng-container>
        }

        <tr *matHeaderRowDef="displayedColumnIds()" mat-header-row></tr>
        <tr
          *matRowDef="let row$; let i = index; columns: displayedColumnIds()"
          mat-row
          [attr.data-cy]="`${id()}_row_${i + 1}`"
        ></tr>
        <tr *matNoDataRow class="mat-row">
          <td class="mat-cell pl-[1rem]" [attr.colspan]="displayedColumnIds().length">
            {{ t('NO_DATA') }}
          </td>
        </tr>
      </table>
    </div>

    @if (showPaginator()) {
      <pct-feature-table-material-table-paginator
        [pagination]="dataPage.pagination"
        [sizeOptions]="paginationSizeOptions()"
        [tableId]="id()"
      />
    }
  </ng-container>
}

@let loading = dataSource().isLoading$ | async;
@if (loading ?? true) {
  <div
    class="flex absolute top-0 left-0 w-full h-full opacity-50 bg-black items-center justify-center"
  >
    <mat-spinner />
  </div>
}
